import { render, staticRenderFns } from "./VideoApplication.vue?vue&type=template&id=126b2fe3&"
import script from "./VideoApplication.vue?vue&type=script&lang=js&"
export * from "./VideoApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports